import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { styled, TextField, ThemeProvider } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import React, { useContext, useState } from "react";
// import CalenderIcon from "../../assets/CalenderIcon.svg";
import { ReactComponent as CalenderIcon } from "../../assets/CalenderIcon.svg";

import { createTheme } from "@mui/material/styles";
import {
  DesktopDateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { enUS, es } from "date-fns/locale";
import { useTranslation } from "react-i18next";
import Toast from "../../components/ToastContainer/CustomToast";
import { ThemeContext } from "../../theme/ThemeContext";

// Custom theme with dynamic darkMode
const MuiTheme = (darkMode) =>
  createTheme({
    palette: {
      mode: darkMode ? "dark" : "light", // Change to mode
      primary: {
        main: process.env.REACT_APP_BG_ICON,
      },
      secondary: {
        main: "#f50057",
      },
    },
  });

// Styled components for icons
const CustomIconLeft = styled(ChevronLeftIcon)(({ theme }) => ({
  color: process.env.REACT_APP_BG_ICON,
  border: process.env.REACT_APP_BG_BORDER,
  borderRadius: "50%",
  "&:hover": {
    backgroundColor: process.env.REACT_APP_BG_ICON,
    color: "#FFFF",
  },
}));

const CustomIconRight = styled(ChevronRightIcon)(({ theme }) => ({
  color: process.env.REACT_APP_BG_ICON,
  border: process.env.REACT_APP_BG_BORDER,
  borderRadius: "50%",
  "&:hover": {
    backgroundColor: process.env.REACT_APP_BG_ICON,
    color: "#FFFF",
  },
}));

// Styled TextField with dynamic darkMode
const StyledTextField = styled(TextField, {
  shouldForwardProp: (prop) => prop !== "darkMode",
})(({ theme, darkMode }) => ({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: darkMode ? "#576A7A" : "#ccc", // Default border color for the fieldset
      borderWidth: "1px", // Set border width to 1px
    },
    "&:hover fieldset": {
      borderColor: darkMode ? "#fafafa" : "rgba(0, 0, 0, 0.4)", // Border color when hovered
    },
    "&.Mui-focused fieldset": {
      borderColor: "rgb(25, 118, 210)", // Border color when focused
    },
    "&.Mui-disabled fieldset": {
      borderColor: darkMode ? "#fff" : "rgba(0, 0, 0, 0.38)", // Border color when disabled
    },
    "&.Mui-disabled": {
      opacity: 1,
      "-webkit-text-fill-color": darkMode ? "#fff" : "rgba(0, 0, 0, 0.38)", // Disabled text color
    },
  },
  "& .MuiInputLabel-root": {
    color: darkMode ? "rgb(160, 158, 158)" : "rgb(160, 158, 158)", // Label color
  },
  "& .MuiFormLabel-root": {
    fontSize: "0.875rem",
  },
  "& .MuiInputBase-input": {
    fontSize: "14px",
    color: darkMode ? "#fff" : "#0F273B", // Default text color
  },
  "& .MuiInputBase-input.Mui-disabled": {
    opacity: 1,
    "-webkit-text-fill-color": darkMode ? "#fff" : "rgba(0, 0, 0, 0.38)", // Disabled text color fix
  },
}));

// Component function
const CustomDateTimePicker = (props) => {
  const { darkMode } = useContext(ThemeContext); // Get darkMode from context
  const [dateOpen, setDateOpen] = useState(false);
  const { t } = useTranslation();
  const [scheduledStartDate, setScheduledStartDate] = React.useState(
    new Date(),
  );

  const handleDate = (e) => {
    setScheduledStartDate(e);
    props.SelectedDate(e);
  };

  const onKeyDown = (e) => {
    e.preventDefault();
    Toast(t("INVITESTARTDATEERROR3"), "error");
  };

  const theme = MuiTheme(darkMode); // Create theme based on darkMode

  // Inline styles for label color
  const labelStyle = {
    color: darkMode ? "#576a7a" : "#ccc",
  };

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider
        dateAdapter={AdapterDateFns}
        adapterLocale={
          props.label.includes("Fecha de inicio") ||
          props.label.includes("Fecha de finalización")
            ? es
            : enUS
        }
      >
        <DesktopDateTimePicker
          disabled={props.disabled}
          hideTabs={false}
          components={{
            OpenPickerIcon: CalenderIcon,
            LeftArrowIcon: CustomIconLeft,
            RightArrowIcon: CustomIconRight,
          }}
          dateRangeIcon={<CalenderIcon />}
          label={
            <span>
              {props.label} <span style={{ color: "red" }}>*</span>
            </span>
          }
          required={props.required ? props.required : false}
          disablePast={props.disablePast}
          disableFuture={props.disableFuture}
          onChange={props.onChange}
          onChangeText={props.onChangeText}
          inputFormat={props.date ? props.date : "MM-dd-yyyy HH:mm"}
          value={props.value}
          minDateTime={props.minDateTime}
          maxDateTime={props.maxDateTime}
          type="datetime-local"
          InputProps={{
            classes: {
              root: "cssOutlinedInput", // Use class name directly if necessary
              focused: "cssFocused",
              notchedOutline: "notchedOutline",
            },
          }}
          renderInput={(params) => (
            <StyledTextField
              onKeyDown={onKeyDown}
              style={{ width: "-webkit-fill-available" }}
              {...params}
              InputLabelProps={{
                style: labelStyle, // Apply dynamic label color
              }}
              darkMode={darkMode} // Pass darkMode prop to StyledTextField
              error={props.error !== undefined ? props.error : params.error}
            />
          )}
        />
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export default CustomDateTimePicker;
